/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  isValidStoredData.ts
 */

import { ExpirableStorageOptions } from '../types/ExpirableStorageOptions'
import { StoredData } from '../types/StoredData'

export const isValidStoredData = <TValue = any>(
  data: StoredData<TValue>,
  options: ExpirableStorageOptions
) => {
  const { ttl, version } = options
  const [, storedVersion, storedTTL, storedAt] = data
  const lifetime = Date.now() - storedAt
  return (
    lifetime < (storedTTL ?? ttl ?? Infinity) &&
    (version ?? true) === (storedVersion ?? true)
  )
}
